export const isDepositNeeded = (balance, stake) => balance !== null && balance < stake;

export const hasZeroBalance = (userBalance) => userBalance !== null && userBalance <= 0;

export const calculateDepositAmount = (balance, stake) => Math.abs(balance - stake);

export const getDepositDetails = (balance, stake, freeBetApplied) => {
    return {
        isDepositNeeded: isDepositNeeded(balance, stake),
        depositAmount: calculateDepositAmount(balance, stake),
        freebetSelected: freeBetApplied,
    };
};
